export * from './lib/emanager-front-shell.module';
